import axios from "axios";
import {
    FETCHING_DATASOURCE_TRANSACTIONS,
    FETCHING_DATASOURCE_TRANSACTIONS_SUCCEEDED,
    FETCHING_DATASOURCE_TRANSACTIONS_FAILED,
    FETCHING_DATASOURCE,
    FETCHING_DATASOURCE_SUCCEEDED,
    FETCHING_DATASOURCE_FAILED,
    FETCHING_DATASOURCE_MAPPINGS,
    FETCHING_DATASOURCE_MAPPINGS_SUCCEEDED,
    FETCHING_DATASOURCE_MAPPINGS_FAILED,
    FETCHING_DATASOURCE_CHILD_MAPPINGS,
    FETCHING_DATASOURCE_CHILD_MAPPINGS_SUCCEEDED,
    FETCHING_DATASOURCE_CHILD_MAPPINGS_FAILED,
    TRIGGER_DATASOURCE_MAPPING_SYNC,
    TRIGGER_DATASOURCE_MAPPING_SYNC_SUCCEDDED,
    TRIGGER_DATASOURCE_MAPPING_SYNC_FAILED
} from "constants/actionTypes";

import { createAction } from "redux-actions"
import { call, takeLatest, put, takeEvery } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const DATSOURCES_BASE_URL = `${API_URL}/api/1.0/datasources`;

// FETCH DATASOURCE
export const fetchDatasource = createAction(FETCHING_DATASOURCE);
const fetchDatasourceSucceeded = createAction(FETCHING_DATASOURCE_SUCCEEDED);
const fetchDatasourceFailed = createAction(FETCHING_DATASOURCE_FAILED);

function* fetchDatasourceSaga(action) {

    const { accountId } = action.payload;

    let url = DATSOURCES_BASE_URL;

    const fetchDatasourceAPI = () => {
        return axios({
            method: "GET",
            url: url,
            params: {
                accountId
            }
        }).then(response => response.data);
    }

    try {
        const response = yield call(fetchDatasourceAPI);
        yield put(fetchDatasourceSucceeded(response));
    }
    catch (error) {
        yield put(fetchDatasourceFailed(error));
    }
}

//FETCH DATASOURCE MAPPINGS
export const fetchDatasourceMappings = createAction(FETCHING_DATASOURCE_MAPPINGS);
const fetchDatasourceMappingsSucceeded = createAction(FETCHING_DATASOURCE_MAPPINGS_SUCCEEDED);
const fetchDatasourceMappingsFailed = createAction(FETCHING_DATASOURCE_MAPPINGS_FAILED);

function* fetchDatasourceMappingsSaga(action) {


    let dataSourceId = action.payload.dataSourceId;

    const url = `${DATSOURCES_BASE_URL}/${dataSourceId}/mappings`;

    const fetchDatasourceMappingsAPI = () => {
        return axios({
            method: 'GET',
            url: url
        }).then(response => response.data)
    }

    try {
        const response = yield call(fetchDatasourceMappingsAPI);
        yield put(fetchDatasourceMappingsSucceeded(response));
    }
    catch (error) {
        console.log("error: ", error);
        yield put(fetchDatasourceMappingsFailed(error))
    }

}

//FETCH DATASOURCE CHILD MAPPINGS
export const fetchDatasourceChildren = createAction(FETCHING_DATASOURCE_CHILD_MAPPINGS);
const fetchDatasourceChildrenSucceeded = createAction(FETCHING_DATASOURCE_CHILD_MAPPINGS_SUCCEEDED);
const fetchDatasourceChildrenFailed = createAction(FETCHING_DATASOURCE_CHILD_MAPPINGS_FAILED)

function* fetchDatasourceChildrenSaga(action) {

    let { dataSourceId, dataSourceMappingId, parent } = action.payload;

    let url = `${DATSOURCES_BASE_URL}/${dataSourceId}/children`;

    const fetchDatasourceChildrenAPI = () => {
        return axios({
            method: 'GET',
            url: url,
            params: {
                parent,
                dataSourceMappingId
            }
        }).then(response => response.data)
    }

    try {
        const response = yield call(fetchDatasourceChildrenAPI);
        yield put(fetchDatasourceChildrenSucceeded(response));
    }
    catch (error) {
        yield put(fetchDatasourceChildrenFailed(error));
    }
}

// FETCH DATASOURCE TRANSACTIONS
export const fetchTransactions = createAction(FETCHING_DATASOURCE_TRANSACTIONS);
const fetchTransactionsSucceeded = createAction(FETCHING_DATASOURCE_TRANSACTIONS_SUCCEEDED);
const fetchTransactionsFailed = createAction(FETCHING_DATASOURCE_TRANSACTIONS_FAILED);

function* fetchTransactionsSaga(action) {

    let { page, limit, filters } = action.payload;
    let accountId = filters.accountId;

    let url = `${DATSOURCES_BASE_URL}/transactions`;

    const fetchTransactionsAPI = () => {
        return axios({
            method: "GET",
            url: url,
            params: { page, limit, accountId }
        }).then(response => response.data);
    }

    try {
        const response = yield call(fetchTransactionsAPI);
        console.log(response);
        yield put(fetchTransactionsSucceeded(response));
    } catch (error) {
        yield put(fetchTransactionsFailed(error));
    }
}

//FETCH SYNC STATUS
export const triggerDataSourceMappingSync = createAction(TRIGGER_DATASOURCE_MAPPING_SYNC);
export const triggerDataSourceMappingSyncSucceeded = createAction(TRIGGER_DATASOURCE_MAPPING_SYNC_SUCCEDDED);
export const triggerDataSourceMappingSyncFailed = createAction(TRIGGER_DATASOURCE_MAPPING_SYNC_FAILED);

function* triggerDataSourceMappingSyncSaga(action) {

    let { id, mappingId } = action.payload;
    let url = `${DATSOURCES_BASE_URL}/${id}/mappings/${mappingId}/sync`;

    const triggerDataSourceMappingSyncAPI = () => {
        return axios({
            method: "PUT",
            url: url
        }).then(response => response.data);
    }

    try {
        const response = yield call(triggerDataSourceMappingSyncAPI);
        console.log(response);
        yield put(triggerDataSourceMappingSyncSucceeded(response));
    } catch (error) {
        yield put(triggerDataSourceMappingSyncFailed(error));
    }
}

export default function* datasourceSaga() {
    yield takeLatest(FETCHING_DATASOURCE, fetchDatasourceSaga);
    yield takeLatest(FETCHING_DATASOURCE_TRANSACTIONS, fetchTransactionsSaga);
    yield takeEvery(FETCHING_DATASOURCE_MAPPINGS, fetchDatasourceMappingsSaga);
    yield takeEvery(FETCHING_DATASOURCE_CHILD_MAPPINGS, fetchDatasourceChildrenSaga);
    yield takeEvery(TRIGGER_DATASOURCE_MAPPING_SYNC, triggerDataSourceMappingSyncSaga);
};

